//资源库首页稿件数 音频数组件封装

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "../../../../../base/BaseComponent";
export default class Statistics  extends BaseComponent {
    static defaultProps = {
    };
    static propTypes = {
    };

    constructor(props) {
        super(props);
        this.state = {
            tabList:[{id:1, name:'全部资源'},{id:2, name:'单位资源'}]
        }
    }

    componentWillMount() {
    }
    componentDidMount() {
    }

    render() {

        return(
            <div style={{width: "230px",
                height:" 120px",
                background: "rgba(0,80,179,0.04)",
                display:'flex',
                alignItems: "center",
                borderRadius: "5px"}}>
                <div  style={{marginLeft:'24px'}}>
                  <img src={this.props.src}/>
                </div>
                <div style={{paddingLeft:'12px'}}>
                    <div style={{color: "rgba(0,0,0,0.85)", fontSize: '30px'}} >{this.props.num}</div>
                    <div style={{color: "rgba(0,0,0,0.45)", fontSize: '14px'}}>{this.props.name}</div>
                </div>

            </div>


        )
    }
}
